import InvitationPage from "./-invitation";
import { invitationSearchSchema } from "@/router/staticData";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/user/invitation")({
  staticData: {
    menuLabel: "邀请有奖",
    showInMenu: true,
    menuGroup: "/user",
    menuOrder: 2,
  },
  validateSearch: invitationSearchSchema,
  component: InvitationPage,
});
